import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useState, useEffect, useRef } from 'react';
import {
  getAllCategories,
  getCategorySubcategories,
} from '../../../api/product-api';
import { SingleCategorySubcategories } from './SingleCategorySubcategories';
import Department from '../../../ui/components/Department';

export const ProductCategoriesShortcut = ({}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [category, setCategory] = useState('');
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const path = window.location.pathname;
    const segments = path.split('/').filter(Boolean);
    setCategory(segments[0]);
  }, []);

  const { data: categoryData, isLoading: isLoadingSubcategories } = useQuery({
    queryKey: ['subcategories', category],
    queryFn: () => getCategorySubcategories(category),
    enabled: !!category,
    retry: false,
  });
  const subcategoryData = categoryData?.data?.subcategories || [];

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
    if (isDropdownOpen) setSelectedDepartment(null);
  };

  const { data } = useQuery({
    queryKey: ['categories'],
    queryFn: () => getAllCategories(),
  });
  const categories = Array.isArray(data?.data?.categories)
    ? data.data.categories
    : [];

  const handleDepartmentClick = (department) => {
    setSelectedDepartment(department);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        !buttonRef.current.contains(e.target)
      ) {
        setIsDropdownOpen(false);
        setSelectedDepartment(null);
      }
    };

    if (isDropdownOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'auto';
    };
  }, [isDropdownOpen]);

  const handleClose = () => {
    setIsDropdownOpen(false);
  };

  const overlayStyle =
    buttonRef.current && isDropdownOpen
      ? {
          top: `${buttonRef.current.getBoundingClientRect().bottom}px`,
          left: 0,
          right: 0,
          bottom: 0,
          position: 'sticky',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 20,
        }
      : {};

  return (
    <section className="sticky md:top-[4.2rem] top-[7.7rem] bg-white z-20 w-full px-5 py-3 mb- overflow-x-auto scrollbar-hide ">
      <div className="flex justify-start gap-5 items-center lg:pb-4">
        <div className="hidden md:block">
          <Department
            isDropdownOpen={isDropdownOpen}
            setIsDropdownOpen={setIsDropdownOpen}
          />
        </div>

        <ul className="flex space-x-4">
          <SingleCategorySubcategories
            subcategory={subcategoryData}
            category={category}
            isLoadingSubcategories={isLoadingSubcategories}
          />
        </ul>
        <Link
          to="/sales-offers/"
          className="hidden lg:flex  font-medium text-[#DB1C5E] text-sm hover:text-[#FF4A8A]  transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-pink-400 rounded text-nowrap"
        >
          Sales & Offers
        </Link>
      </div>
    </section>
  );
};
